import { Circle, Line } from "../common/loader";
import { Flex, Box } from "rebass/styled-components";

const CardPlaceholder = () => (
  <Flex py={2} flexWrap="wrap" sx={{ borderBottom: "default" }}>
    <Box width={[2 / 7, 1 / 5]}>
      <Circle height={64}></Circle>
    </Box>
    <Box width={[5 / 7, 4 / 5]}>
      <Line count={1} space={5} width={"70%"}></Line>
      <Line count={2} size={14} space={7}></Line>
    </Box>
  </Flex>
);

const ResultListPlaceholder = () => (
  <Box
    px={1}
    sx={{
      position: "relative",
      ":after": {
        content: `""`,
        position: "absolute",
        zIndex: 1,
        bottom: 0,
        left: 0,
        pointerEvents: "none",
        backgroundImage: `linear-gradient(to bottom, rgba(255,255,255, 0), rgba(255,255,255, 0.9) 90%)`,
        width: "100%",
        height: ["20%", "15%"]
      }
    }}
  >
    <CardPlaceholder />
    <CardPlaceholder />
    <CardPlaceholder />
    <CardPlaceholder />
    <CardPlaceholder />
    <CardPlaceholder />
    <CardPlaceholder />
  </Box>
);

export default ResultListPlaceholder;
